import React, { useState } from "react";
import Cateringordersdetails from "./Cateringordersdetails";
import CateringPackages from "./CateringPackages";

import Vendorquotation from "./Vendorquotation";
import Vendors from "./Vendors";


const TabsLayout = () => {
  const [activeTab, setActiveTab] = useState("Enquiry");

  const DummySection = ({ title }) => (
    <div className="dummy-box">
      <h2>{title}</h2>
      <p>This is a dummy section for <strong>{title}</strong>.</p>
      <span>Content will be added later 🚧</span>
    </div>
  );

  const renderComponent = () => {
    switch (activeTab) {
      case "Enquiry":
        return <Cateringordersdetails />;
      case "Lead Acceptance":
        return <Vendors />;
      case "Quotation":
        return <Vendorquotation title="Quotation" />;
      case "History":
        return <CateringPackages title="History" />;

      default:
        return <Cateringordersdetails />;
    }
  };

  const tabs = [
    "Enquiry",
    "Lead Acceptance",
    "Quotation",
    "History",

  ];

  return (
    <div className="tabs-wrapper">
      {/* TOP ONE-ROW TABS (ALL SCREENS) */}
      <div className="tabs-row">
        {tabs.map((tab) => (
          <span
            key={tab}
            className={`row-tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </span>
        ))}
      </div>

      {/* CONTENT */}
      <div className="tabs-content" style={{ height: "88vh", overflow: "auto", scrollbarWidth: "none" }}>
        {renderComponent()}
      </div>
    </div>
  );
};

export default TabsLayout;

